import { apiClient, type Paginated } from '@/core/api';

import type { AuditEntry } from './types';

const BASE = '/audit/logs/';

export interface AuditTimelineParams {
  /** ContentType id resolved from the entity label. */
  contentTypeId: number;
  /** Target PK — the BE keys object_id as a string. */
  entityId: string | number;
}

/**
 * Per-target audit timeline. BE requires both `content_type` and `object_id`
 * to be present — when they are, any staff member in the active org can read.
 */
export async function listAuditTimeline(
  { contentTypeId, entityId }: AuditTimelineParams,
): Promise<AuditEntry[]> {
  const { data } = await apiClient.get<Paginated<AuditEntry>>(BASE, {
    params: { content_type: contentTypeId, object_id: String(entityId) },
  });
  return data.results;
}
